import { render, staticRenderFns } from "./MitMenuManager.vue?vue&type=template&id=035d4799&scoped=true"
import script from "./MitMenuManager.vue?vue&type=script&lang=js"
export * from "./MitMenuManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d4799",
  null
  
)

export default component.exports